type StatCardProps = {
  label: string;
  value: string | number;
  description: string;
};

export default function StatCard({ label, value, description }: StatCardProps) {
  return (
    <div className="rounded-lg border border-[#E6EEF2] bg-white p-4 shadow-sm">
      <p className="text-sm font-medium text-[#556C75]">{label}</p>
      <p className="mt-2 text-3xl font-semibold text-[#2B4752]">{value}</p>
      <p className="mt-2 text-xs text-[#7F7F7F]">{description}</p>
    </div>
  );
}
